module.exports = __webpack_public_path__ + "static/media/check-ticket.4507a406.svg";